import { jsx as _jsx } from "react/jsx-runtime";
import { semantic } from "@diligentcorp/atlas-design-tokens";
import ExpandDownIcon from "@diligentcorp/atlas-react-icons/ExpandDown.js";
import { getButtonTokens } from "../utils/createAtlasButtonVariant.js";
import { getInputTokens } from "./inputBase.js";
import { getDropdownTokens } from "./select.js";
const maximumOptionsInTheList = 6;
const getIconStyles = (tokens) => {
    const { input, dropdown, spacing } = getDropdownTokens(tokens);
    const { button } = getButtonTokens(tokens);
    return {
        color: dropdown.icon.color.value,
        "&.MuiIconButton-root": {
            height: "auto",
            width: "auto",
            padding: spacing.xs.value,
            "& + .MuiIconButton-root": {
                marginLeft: parseInt(spacing.lg.value) - parseInt(spacing.xs.value),
            },
            ":not(.MuiAutocomplete-popupIndicator)": {
                "&:hover": {
                    backgroundColor: button.tertiary.hover.backgroundColor.value,
                },
                "&:active": {
                    backgroundColor: button.tertiary.active.backgroundColor.value,
                },
            },
        },
        "&.Mui-disabled": {
            color: input.disabled.icon.color.value,
        },
        "&:hover": {
            color: dropdown.icon.color.value,
        },
        "&, &:active, &:hover": {
            backgroundColor: "transparent",
        },
    };
};
const autocomplete = (tokens) => {
    const { input } = getInputTokens(tokens);
    const sharedIconStyles = getIconStyles(tokens);
    const { dropdown, spacing } = getDropdownTokens(tokens);
    const optionMinHeight = dropdown.item.minHeight.value;
    const inputButtonSize = parseInt(input.icon.width.value) + 2 * parseInt(spacing.xs.value);
    const inputButtonSpacing = parseInt(spacing.lg.value) - parseInt(spacing.xs.value);
    return {
        MuiAutocomplete: {
            defaultProps: {
                popupIcon: _jsx(ExpandDownIcon, {}),
            },
            styleOverrides: {
                root: {
                    "&.MuiAutocomplete-hasClearIcon, &.MuiAutocomplete-hasPopupIcon": {
                        ".MuiAutocomplete-inputRoot": {
                            paddingRight: inputButtonSize + parseInt(input.paddingHorizontal.value),
                        },
                    },
                    "&.MuiAutocomplete-hasClearIcon.MuiAutocomplete-hasPopupIcon": {
                        ".MuiAutocomplete-inputRoot": {
                            paddingRight: 2 * inputButtonSize + inputButtonSpacing + parseInt(input.paddingHorizontal.value),
                        },
                    },
                },
                inputRoot: ({ ownerState }) => ({
                    paddingLeft: input.paddingHorizontal.value,
                    paddingTop: (ownerState === null || ownerState === void 0 ? void 0 : ownerState.size) === "large"
                        ? input.large.paddingVertical.value
                        : input.paddingVertical.value,
                    paddingBottom: (ownerState === null || ownerState === void 0 ? void 0 : ownerState.size) === "large"
                        ? input.large.paddingVertical.value
                        : input.paddingVertical.value,
                    ".MuiAutocomplete-endAdornment": {
                        top: `calc(50% - ${inputButtonSize / 2}px)`,
                        right: input.paddingHorizontal.value,
                    },
                    gap: input.gap.value,
                }),
                input: ({ ownerState }) => (Object.assign({ "&.MuiAutocomplete-input": {
                        padding: 0,
                    }, "&.MuiInputBase-inputAdornedStart": {
                        paddingLeft: input.gap.value,
                    }, "&.MuiInputBase-inputAdornedEnd": {
                        paddingRight: input.gap.value,
                    } }, ((ownerState === null || ownerState === void 0 ? void 0 : ownerState.multiple) && { flexBasis: "100%" }))),
                tag: {
                    margin: 0,
                },
                popupIndicator: sharedIconStyles,
                popupIndicatorOpen: {
                    transform: "none",
                },
                clearIndicator: sharedIconStyles,
                listbox: {
                    maxHeight: `calc(${maximumOptionsInTheList} * ${optionMinHeight})`,
                    paddingTop: 0,
                    paddingBottom: 0,
                    ".MuiAutocomplete-option.Mui-focused": {
                        backgroundColor: dropdown.item.hover.backgroundColor.value,
                        boxShadow: semantic.shadow.focusInset.value.stringValue,
                    },
                    '.MuiAutocomplete-option[aria-selected="true"]': {
                        backgroundColor: dropdown.item.selected.backgroundColor.value,
                    },
                    '.MuiAutocomplete-option[aria-selected="true"].Mui-focused': {
                        backgroundColor: dropdown.item.hover.backgroundColor.value,
                    },
                },
                paper: {
                    backgroundColor: dropdown.overlay.backgroundColor.value,
                    borderRadius: dropdown.overlay.borderRadius.value,
                    boxShadow: dropdown.overlay.boxShadow.value.stringValue,
                },
                option: {
                    "&.MuiAutocomplete-option": {
                        minHeight: optionMinHeight,
                        paddingLeft: dropdown.item.paddingHorizontal.value,
                        paddingRight: dropdown.item.paddingHorizontal.value,
                        gap: semantic.spacing.md.value,
                    },
                },
                groupLabel: {
                    paddingLeft: dropdown.item.paddingHorizontal.value,
                    top: 0,
                },
            },
        },
    };
};
export default autocomplete;
//# sourceMappingURL=autocomplete.js.map